import { adminProductsService } from "../../api_client";
import { usePaginatedApi } from "../../../swr";
import type { ProductsQueryDto } from "../../../api";

interface PartnerProductsQuery {
  page?: number;
  pageSize?: number;
}

// sellerPartnerId is not in generated ProductsQueryDto because Swagger resolves
// AdminProductsQueryDto (extends ProductsQueryDto) to its base type — cast is safe,
// the backend correctly binds the field at runtime.
export function usePartnerProducts(sellerId: number, query?: PartnerProductsQuery) {
  return usePaginatedApi({
    key: `/admin/products?sellerPartnerId=${sellerId}`,
    serviceMethod: (q) => adminProductsService.adminGetProducts(q),
    query: { ...query, sellerPartnerId: sellerId } as ProductsQueryDto,
  });
}
